/**
 * @abstract
 */
export default class CSSTransformAdapter {
	transform() {
		throw new Error('The adapter must implement this method.');
	}
}
